import { defineMessages, useIntl } from 'react-intl'
import { Box, Button, Flex, Icon, Stack, Text, useTheme } from '@homebotapp/hb-react-component-catalog'
import vacationIconDark from '../../../../features/homeSearch/assets/vacation-icon-dark.svg'
import vacationIconLight from '../../../../features/homeSearch/assets/vacation-icon-light.svg'
import { HomeSearchTrackingEventLocation } from '../../../../constants/tracking'
import { useCreateClientEvent } from '../../../../hooks/useCreateClientEvent'
import { ClientEventName, ClientEventSource } from '../../../../api/gqlaxy/gql/generated/graphql'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { selectClientIsGuest } from '../../../../store/selectors/client'

interface ShortTermRentalProps {
  setIsExpanded: (isExpanded: boolean) => void
  listingId: string
}

export const MSG = defineMessages({
  head: {
    id: 'ShortTermRentalCardCollapsed.head',
    defaultMessage: 'See how much you could earn by renting this home on Airbnb'
  },
  button: {
    id: 'ShortTermRentalCardCollapsed.button',
    defaultMessage: 'Calculate rental income'
  }
})

export const ShortTermRentalCardCollapsed: React.FC<ShortTermRentalProps> = ({ setIsExpanded, listingId }) => {
  const intl = useIntl()

  const { theme } = useTheme()

  const isGuest = useSelector(selectClientIsGuest)

  const { mutateAsync: createClientEvent } = useCreateClientEvent({ disableErrorPrompts: true })

  const createShortTermRentalLearnMoreClickedEvent = useCallback(() => {
    createClientEvent({
      clientEventInput: {
        eventName: ClientEventName.ShortTermRentalCtaClick,
        eventSource: ClientEventSource.ListingDetailed,
        listingId: listingId
      }
    })
  }, [createClientEvent])

  const handleClick = () => {
    if (!isGuest) createShortTermRentalLearnMoreClickedEvent()

    setIsExpanded(true)
  }

  return (
    <Stack gap={2} justifyContent='center'>
      <Flex
        gap={2}
        alignItems='center'
        flexDirection={['row', null, 'column']}
        justifyContent='space-around'
        px={[4, null, null, 0]}
      >
        <Box
          height={12}
          width={12}
          flexShrink={0}
          borderRadius='50%'
          backgroundColor='neutral.300'
          backgroundSize='cover'
          backgroundPosition='center'
          backgroundImage={`url(${theme.isLightNeutral ? vacationIconDark : vacationIconLight})`}
        />
        <Text color='neutral-900' mb={0}>
          {intl.formatMessage(MSG.head)}
        </Text>
      </Flex>
      <Button
        colorScheme='primary'
        variant='ghost'
        rightIcon={<Icon name='circle-arrow-right-bts' />}
        width='100%'
        tracking={{
          guid: 'emzycuVsSGfKtPTkmsytEt',
          descriptor: intl.formatMessage(MSG.button),
          ui_context: HomeSearchTrackingEventLocation.HOME_SEARCH_LISTING_DETAILS_SHORT_TERM_RENTAL_CALCULATE_BUTTON
        }}
        onClick={handleClick}
      >
        {intl.formatMessage(MSG.button)}
      </Button>
    </Stack>
  )
}
